import {} from "@siteimprove/alfa-comparable";
import { None } from "./none.js";
import { Some } from "./some.js";
/**
 * @public
 */
export var Option;
(function (Option) {
    function isOption(value) {
        return isSome(value) || isNone(value);
    }
    Option.isOption = isOption;
    function isSome(value) {
        return Some.isSome(value);
    }
    Option.isSome = isSome;
    function isNone(value) {
        return value === None;
    }
    Option.isNone = isNone;
    function of(value) {
        return Some.of(value);
    }
    Option.of = of;
    function empty() {
        return None;
    }
    Option.empty = empty;
    function from(value) {
        return value === null || value === undefined ? None : Some.of(value);
    }
    Option.from = from;
    function conditional(value, predicate) {
        return predicate(value) ? Some.of(value) : None;
    }
    Option.conditional = conditional;
})(Option || (Option = {}));
//# sourceMappingURL=option.js.map